class HeaderSticky extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      announcement: this.querySelector('#header-announcement'),
    };

    // Run methods
    this.headerResize();
    // this.initAnnouncement();
  }

  // Define methods
  headerResize() {
    // Create resize observer that runs on header resize and saves the height to a css variable
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { height } = entry.contentRect;
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      }
    });
    resizeObserver.observe(this.firstElementChild);
  }
}
customElements.define('header-sticky', HeaderSticky);
